import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

// Бренд-палитра лендинга (landing/src/app/globals.css): сигнальный оранжевый = primary,
// near-black ink = surface. Шкалы построены вокруг --race-orange / --race-ink.
const orange = {
  50: 'oklch(0.97 0.03 50)',
  100: 'oklch(0.94 0.06 48)',
  200: 'oklch(0.88 0.1 46)',
  300: 'oklch(0.82 0.14 44)',
  400: 'oklch(0.76 0.18 43)',
  500: 'oklch(0.7 0.2 42)',
  600: 'oklch(0.63 0.19 40)',
  700: 'oklch(0.54 0.17 38)',
  800: 'oklch(0.45 0.14 36)',
  900: 'oklch(0.38 0.11 35)',
  950: 'oklch(0.27 0.08 34)',
}

// Тёплый ink-нейтральный surface: 950 = --race-ink, 50/100 — «бумажные» под светлую тему.
const surface = {
  0: '#ffffff',
  50: 'oklch(0.985 0.002 75)',
  100: 'oklch(0.96 0.003 75)',
  200: 'oklch(0.92 0.004 75)',
  300: 'oklch(0.87 0.004 75)',
  400: 'oklch(0.71 0.005 75)',
  500: 'oklch(0.56 0.005 75)',
  600: 'oklch(0.44 0.005 75)',
  700: 'oklch(0.37 0.005 75)',
  800: 'oklch(0.27 0.005 75)',
  900: 'oklch(0.21 0.005 75)',
  950: 'oklch(0.17 0.005 75)',
}

// Оранжевый светлый → тёмный текст на кнопках/чипах (как --primary-foreground лендинга).
const ink = 'oklch(0.17 0.005 75)'

export const shaganPreset = definePreset(Aura, {
  primitive: {
    // Брутализм-сигнал: квадратные углы у всех компонентов.
    borderRadius: { none: '0', xs: '0', sm: '0', md: '0', lg: '0', xl: '0' },
  },
  semantic: {
    primary: orange,
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: ink,
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
        surface,
      },
      dark: {
        primary: {
          color: '{primary.400}',
          contrastColor: ink,
          hoverColor: '{primary.300}',
          activeColor: '{primary.200}',
        },
        surface,
      },
    },
  },
})
